import { FC, useState } from 'react';

import { Button } from 'components/parts/Button';
import { Dialog } from 'components/parts/Dialog';
import CloseIconWhite from 'images/icon/close_white.svg';

import styles from '../Card.module.scss';

import { getClearCardFileName, formatCardName } from 'components/pages/Card/model/helpers';
import { CardItem } from 'components/pages/Card/model/types';

type Props = { card: CardItem; handleClose: () => void };

export const CaredModalView: FC<Props> = ({ card, handleClose }) => {
  // 表面・裏面を切り替えるためのstate
  const [isFront, setIsFront] = useState(true);

  // モーダル内の画像をクリックした時のイベントハンドラ
  const handleFlipCard = () => {
    setIsFront(!isFront);
  };

  const isMission = card.type === 'mission';

  return (
    <Dialog isOpen={true} addClass={[styles.dialogCard]} handleClose={handleClose}>
      <div className={styles.dialogCardHead}>
        <button type="button" className={styles.dialogCardCloseIconButton} onClick={handleClose}>
          <img src={CloseIconWhite} alt="閉じる" className={styles.dialogCardCloseIcon} />
        </button>
      </div>
      <div className={styles.dialogCardBody}>
        <button
          onClick={handleFlipCard}
          className={styles.slipCardButton}
          data-flip-front={!isFront}
        >
          <div className={styles.frontSideWrap}>
            <img
              className={styles.frontSideImage}
              aria-hidden={!isFront}
              src={require(`components/pages/Area/images/${getClearCardFileName(card)}`)}
              alt={`クリアカード表面：${formatCardName(card?.name, false)}`}
            />
          </div>
          <div className={styles.backSideWrap}>
            <img
              className={styles.backSideImage}
              aria-hidden={isFront}
              src={
                isMission
                  ? require(`components/pages/Area/images/back_mission-clear-card.webp`)
                  : require(`components/pages/Area/images/back_clear-card.webp`)
              }
              alt={isMission ? 'ミッションカード裏面' : 'クリアカード裏面'}
            />
          </div>
        </button>
      </div>
      <div className={styles.dialogCardFoot}>
        <Button text="閉じる" styleType="secondary" handleClick={handleClose} />
      </div>
    </Dialog>
  );
};
